// extracted by mini-css-extract-plugin
export default {"header":"messenger-header-action-buttons_header__xDkji","header-button":"messenger-header-action-buttons_header-button__QgU6C"};